import { FilterGroup } from '../models/FilterGroup.model';
import { GuideState } from '../models/Guide.model';
import { FiniNotification } from '../models/Notifications.model';
import { PaginationState } from '../models/Pagination';
import { AccountFlag, ApiServer, ApiUser } from '../models/Profile.model';
import { BillingStateSchema } from './billing.service';
import { StateService } from './state.service';

export class AppState {
  static persistedKeys: (keyof AppState)[] = [
    'token',
    'user',
    'servers',
    'selectedServerIdx',
    'apolloIp',
    'themeName',
    'selectedConfProfileId',
    'language',
    'languages',
    'notifications',
    'localFilterGroups',
    'guides',
    'pagination',
    'flags',
    'featureFlags',
    'postRegistrationDetails',
    'configEpIgnoreList',
    'tableOptions',
    'impersonate',
    'realToken',
  ]; // All keys that should be kept in localStorage

  token: string = null;
  user: ApiUser = null;
  servers: ApiServer[] = [];
  selectedServerIdx = 0;
  service: StateService;
  profileCached: Date = new Date(0);
  apolloIp: Record<number, string> = {};
  themeName: 'light' | 'dark' = 'light';
  permissions: string[] = [];
  selectedConfProfileId = 0;
  language = 'en';
  languages = ['en', 'de', 'se', 'tr'];
  notifications: FiniNotification[] = [];
  localFilterGroups: FilterGroup[] = [];
  guides: { [key: string]: GuideState } = {};
  pagination: PaginationState = {};
  flags: AccountFlag[] = [];
  initialized = false;
  featureFlags: { [key: string]: boolean } = {};
  setup = {
    authorizedIp: '',
  };
  payments: BillingStateSchema = {};
  postRegistrationDetails: {
    username?: string;
    password?: string;
  } = {};
  configEpIgnoreList: string[] = [];
  tableOptions: { [key: string]: { hiddenRows: string[] } } = {};
  lastDiscordLogin: number = 0;
  impersonate: boolean;
  realToken: string;
  apolloVideoStreamTriedSTUN: boolean = false;

  get isAuthenticated(): boolean {
    return !!this.token;
  }

  set isAuthenticated(b: boolean) {
    throw new Error(
      `State: Cannot set 'isAuthenticated' directly. Set 'token'.`,
    );
  }

  get apolloSavedIp(): string {
    return this.apolloIp[this.selectedServer.id];
  }

  set apolloSavedIp(ip: string) {
    this.service.set({
      apolloIp: { ...this.apolloIp, [this.selectedServer.id]: ip },
    });
  }

  get hasServers(): boolean {
    if (this.servers && this.servers.length > 0) {
      return true;
    }
    return false;
  }

  get selectedServer(): ApiServer {
    if (!this.servers) {
      return null;
    }

    if (this.selectedServerIdx >= this.servers.length) {
      this.selectedServerIdx = 0;
    }
    return this.servers[this.selectedServerIdx];
  }

  set selectedServer(server: ApiServer) {
    let idx = 0;
    for (const srv of this.servers) {
      if (srv.id == server.id) {
        this.service.set({ selectedServerIdx: idx });

        return;
      }
      idx++;
    }
    this.service.set({ selectedServerIdx: 0 });
  }

  get theme(): 'light' | 'dark' {
    return this.themeName;
  }

  set theme(newName: 'light' | 'dark') {
    const currentName = this.themeName;
    if (document) {
      document.body.classList.remove(`${currentName}-theme`);
      document.body.classList.add(`${newName}-theme`);
    }

    this.service.set({ themeName: newName });
    this.themeName = newName;
  }
}
